import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PostalAddressableSchema = withDefaults({
  type: 'postal-addressable',
  fields: [
    {
      kind: 'hasMany',
      name: 'postalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: 'commentable',
        as: 'commentable',
      },
    },
  ],
});

export default PostalAddressableSchema;
